// removed by extract-text-webpack-plugin
module.exports = {"ContactData":"admin__ContactData___2Shcg","progressBar":"admin__progressBar___3pRm_","blue":"admin__blue___3jK3-","stripes":"admin__stripes___2Z9OI","animate-stripes":"admin__animate-stripes___YW-4M"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/admin/admin.css
// module id = 56
// module chunks = 0